"use strict";

exports.__esModule = true;
exports.filterObject = void 0;
/**
 * filterObject is a utility function for excluding desired properties from an object. It works similar to Array.prototype.filter.
 * This function should be used instead of Object.fromEntries(Object.entries(object).filter(...))
 *
 * @param {object} object - original object to be filtered
 * @param {function} filter - function of signature (key, value) => boolean. executed for each property in `object`
 * @return {object}
 */
var filterObject = exports.filterObject = function filterObject(object) {
  var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => true;
  var output = {};
  for (var key in object) {
    if (object.hasOwnProperty(key) && filter(key, object[key])) {
      output[key] = object[key];
    }
  }
  return output;
};
//# sourceMappingURL=filterObject.js.map